import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Region } from '../models/region.model';

export interface RegionsResponse {
  regions: Region[];
}

/**
 * Public (any authenticated user, not super-admin-only) read of the address-registry region
 * catalog — see backend/src/routes/registry.ts. The map uses this to find every `ready`
 * region and load its pmtiles as its own source (map.component.ts); registry data is shared
 * across every org, not assigned per-customer, so there's no org-scoped variant of this call.
 */
@Injectable({ providedIn: 'root' })
export class RegionsService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  getRegions(): Observable<RegionsResponse> {
    return this.http.get<RegionsResponse>(`${this.apiUrl}/regions`);
  }
}
